export const linkes = [
  {
    id: 0,
    descricao: "Home",
    icon: "./assets/icons/sidebar-icons/exercices.svg",
    path: "/dashboard",
  },
  {
    id: 1,
    descricao: "Treinos",
    icon: "./assets/icons/sidebar-icons/muscle.svg",
    path: "/treino",
  },
  {
    id: 2,
    descricao: "Pesos",
    icon: "./assets/icons/sidebar-icons/pesos.svg",
    path: "/pesos",
  }
];
